<template>
  <div class="tours-container">
    <div class="tours-top-container">
      <app-navbar rootClassName="navbar-root-class-name1"></app-navbar>
      <div class="tours-hero">
        <div class="tours-container1">
          <h1 class="tours-text heading">Hand picked tours</h1>
          <h2 class="tours-subheading subheading">An unique experience</h2>
        </div>
        <div class="tours-content-container">
          <div class="tours-container2"></div>
        </div>
      </div>
    </div>
    <div id="main-section" class="tours-main">
      <app-component></app-component>
      <div class="tours-blog">
        <div class="tours-container3">
          <router-link to="/landing-page" class="tours-navlink">
            <tour-card-left
              label="1 day"
              title="Coast to Coast"
              image_src="https://unsplash.com/photos/YGGv1hdokNk/download?ixid=MnwxMjA3fDB8MXxhbGx8fHx8fHx8fHwxNjQ5NTE3MTUw&amp;force=true&amp;w=1920"
              profile_src="https://images.unsplash.com/photo-1611232658409-0d98127f237f?ixid=Mnw5MTMyMXwwfDF8c2VhcmNofDIzfHxwb3J0cmFpdCUyMHdvbWFufGVufDB8fHx8MTYyNjQ1MDU4MQ&amp;ixlib=rb-1.2.1&amp;h=1200"
              rootClassName="tour-card-left-root-class-name3"
              class="tours-component2"
            ></tour-card-left>
          </router-link>
          <tour-card-left
            label="1 day"
            title="Inner Madeira"
            image_src="https://unsplash.com/photos/_kdKNKFt7tg/download?force=true&amp;w=1920"
            profile_src="https://images.unsplash.com/photo-1611232658409-0d98127f237f?ixid=Mnw5MTMyMXwwfDF8c2VhcmNofDIzfHxwb3J0cmFpdCUyMHdvbWFufGVufDB8fHx8MTYyNjQ1MDU4MQ&amp;ixlib=rb-1.2.1&amp;h=1200"
            rootClassName="tour-card-left-root-class-name"
          ></tour-card-left>
          <router-link to="/east" class="tours-navlink1">
            <tour-card-left
              label="1/2 Day"
              title="Above the clouds"
              image_src="https://unsplash.com/photos/e7UkeuLYK6s/download?ixid=MnwxMjA3fDB8MXxhbGx8fHx8fHx8fHwxNjQ5NTE3Nzk2&amp;force=true&amp;w=1920"
              profile_src="https://images.unsplash.com/photo-1611232658409-0d98127f237f?ixid=Mnw5MTMyMXwwfDF8c2VhcmNofDIzfHxwb3J0cmFpdCUyMHdvbWFufGVufDB8fHx8MTYyNjQ1MDU4MQ&amp;ixlib=rb-1.2.1&amp;h=1200"
              rootClassName="tour-card-left-root-class-name1"
              class="tours-component4"
            ></tour-card-left>
          </router-link>
        </div>
      </div>
    </div>
    <div class="tours-footer">
      <div class="tours-menu">
        <h1>
          <span>Madeira</span>
          <br />
          <span>Roots</span>
        </h1>
        <div class="tours-links-container">
          <div class="tours-container4">
            <a
              href="https://example.com"
              target="_blank"
              rel="noreferrer noopener"
              class="tours-link"
            >
              Tour packages
            </a>
            <a
              href="https://example.com"
              target="_blank"
              rel="noreferrer noopener"
              class="tours-link01"
            >
              Personalized to
            </a>
            <a
              href="https://example.com"
              target="_blank"
              rel="noreferrer noopener"
              class="tours-link02"
            >
              Special deals
            </a>
            <a
              href="https://example.com"
              target="_blank"
              rel="noreferrer noopener"
              class="tours-link03"
            >
              Summer holiday
              <span v-html="rawsah6"></span>
            </a>
          </div>
          <div class="tours-container5">
            <a
              href="https://example.com"
              target="_blank"
              rel="noreferrer noopener"
              class="tours-link04"
            >
              About us
            </a>
            <a
              href="https://example.com"
              target="_blank"
              rel="noreferrer noopener"
              class="tours-link05"
            >
              FAQ
            </a>
            <a
              href="https://example.com"
              target="_blank"
              rel="noreferrer noopener"
              class="tours-link06"
            >
              Terms and conditions
            </a>
            <a
              href="https://example.com"
              target="_blank"
              rel="noreferrer noopener"
              class="tours-link07"
            >
              Contact
            </a>
          </div>
        </div>
        <div class="tours-follow-container">
          <span class="tours-text4">
            Follow us on
            <span v-html="rawpjqs"></span>
          </span>
          <div class="tours-icons-container">
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noreferrer noopener"
              class="tours-link08"
            >
              <svg viewBox="0 0 877.7142857142857 1024" class="tours-icon">
                <path
                  d="M585.143 512c0-80.571-65.714-146.286-146.286-146.286s-146.286 65.714-146.286 146.286 65.714 146.286 146.286 146.286 146.286-65.714 146.286-146.286zM664 512c0 124.571-100.571 225.143-225.143 225.143s-225.143-100.571-225.143-225.143 100.571-225.143 225.143-225.143 225.143 100.571 225.143 225.143zM725.714 277.714c0 29.143-23.429 52.571-52.571 52.571s-52.571-23.429-52.571-52.571 23.429-52.571 52.571-52.571 52.571 23.429 52.571 52.571zM438.857 152c-64 0-201.143-5.143-258.857 17.714-20 8-34.857 17.714-50.286 33.143s-25.143 30.286-33.143 50.286c-22.857 57.714-17.714 194.857-17.714 258.857s-5.143 201.143 17.714 258.857c8 20 17.714 34.857 33.143 50.286s30.286 25.143 50.286 33.143c57.714 22.857 194.857 17.714 258.857 17.714s201.143 5.143 258.857-17.714c20-8 34.857-17.714 50.286-33.143s25.143-30.286 33.143-50.286c22.857-57.714 17.714-194.857 17.714-258.857s5.143-201.143-17.714-258.857c-8-20-17.714-34.857-33.143-50.286s-30.286-25.143-50.286-33.143c-57.714-22.857-194.857-17.714-258.857-17.714zM877.714 512c0 60.571 0.571 120.571-2.857 181.143-3.429 70.286-19.429 132.571-70.857 184s-113.714 67.429-184 70.857c-60.571 3.429-120.571 2.857-181.143 2.857s-120.571 0.571-181.143-2.857c-70.286-3.429-132.571-19.429-184-70.857s-67.429-113.714-70.857-184c-3.429-60.571-2.857-120.571-2.857-181.143s-0.571-120.571 2.857-181.143c3.429-70.286 19.429-132.571 70.857-184s113.714-67.429 184-70.857c60.571-3.429 120.571-2.857 181.143-2.857s120.571-0.571 181.143 2.857c70.286 3.429 132.571 19.429 184 70.857s67.429 113.714 70.857 184c3.429 60.571 2.857 120.571 2.857 181.143z"
                ></path>
              </svg>
            </a>
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noreferrer noopener"
              class="tours-link09"
            >
              <svg viewBox="0 0 602.2582857142856 1024" class="tours-icon2">
                <path
                  d="M548 6.857v150.857h-89.714c-70.286 0-83.429 33.714-83.429 82.286v108h167.429l-22.286 169.143h-145.143v433.714h-174.857v-433.714h-145.714v-169.143h145.714v-124.571c0-144.571 88.571-223.429 217.714-223.429 61.714 0 114.857 4.571 130.286 6.857z"
                ></path>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppNavbar from '../components/navbar'
import AppComponent from '../components/component'
import TourCardLeft from '../components/tour-card-left'

export default {
  name: 'Tours',
  components: {
    AppNavbar,
    AppComponent,
    TourCardLeft,
  },

  data() {
    return {
      rawsah6: ' ',
      rawpjqs: ' ',
    }
  },

  metaInfo: {
    title: 'Tours - Madeira Roots',
    meta: [
      {
        name: 'description',
        content: 'Deep dive into Madeira Roots',
      },
      {
        property: 'og:title',
        content: 'Tours - Madeira Roots',
      },
      {
        property: 'og:description',
        content: 'Deep dive into Madeira Roots',
      },
    ],
  },
}
</script>

<style scoped>
.tours-container {
  width: 100%;
  height: auto;
  display: flex;
  min-height: 100vh;
  align-items: center;
  flex-direction: column;
}
.tours-top-container {
  width: 100%;
  height: 600px;
  display: flex;
  align-items: center;
  flex-direction: column;
  background-size: cover;
  background-image: radial-gradient(circle at center, rgba(119, 109, 73, 0.2) 36.00%,rgba(70, 67, 56, 0.8) 100.00%),url('https://unsplash.com/photos/IUY_3DvM__w/download?force=true&w=1920');
  background-position: 0% 40%;
}
.tours-hero {
  flex: 1;
  width: 100%;
  display: flex;
  position: relative;
  max-width: 1000px;
  padding-top: var(--dl-space-space-tripleunit);
  padding-left: var(--dl-space-space-doubleunit);
  padding-right: var(--dl-space-space-doubleunit);
  flex-direction: column;
  padding-bottom: var(--dl-space-space-tripleunit);
  justify-content: center;
}
.tours-container1 {
  top: 80px;
  left: 32px;
  display: flex;
  position: absolute;
  align-self: flex-start;
  align-items: flex-start;
  flex-direction: column;
  justify-content: flex-start;
}
.tours-text {
  color: #ffffff;
}
.tours-subheading {
  color: #ffffff;
}
.tours-content-container {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}
.tours-container2 {
  flex: 0 0 auto;
  width: auto;
  border: 2px dashed rgba(120, 120, 120, 0.4);
  height: auto;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
}
.tours-main {
  width: 100%;
  display: flex;
  align-items: center;
  padding-top: var(--dl-space-space-quadruple);
  padding-left: var(--dl-space-space-doubleunit);
  padding-right: var(--dl-space-space-doubleunit);
  flex-direction: column;
  padding-bottom: var(--dl-space-space-quadruple);
  justify-content: flex-start;
}
.tours-blog {
  width: 100%;
  display: flex;
  padding: 48px;
  max-width: 1400px;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
}
.tours-container3 {
  display: flex;
  align-items: center;
  margin-bottom: 32px;
  flex-direction: column;
  justify-content: space-between;
}
.tours-navlink {
  display: contents;
}
.tours-component2 {
  text-decoration: none;
}
.tours-navlink1 {
  display: contents;
}
.tours-component4 {
  text-decoration: none;
}
.tours-footer {
  color: var(--dl-color-gray-white);
  width: 100%;
  display: flex;
  padding: var(--dl-space-space-tripleunit);
  align-items: center;
  flex-direction: row;
  justify-content: center;
  background-color: var(--dl-color-gray-black);
}
.tours-menu {
  width: 100%;
  display: flex;
  max-width: 1000px;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
}
.tours-links-container {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
}
.tours-container4 {
  display: flex;
  align-items: flex-start;
  margin-left: 100px;
  flex-direction: column;
}
.tours-link {
  margin-bottom: var(--dl-space-space-unit);
  text-decoration: none;
}
.tours-link01 {
  margin-bottom: var(--dl-space-space-unit);
  text-decoration: none;
}
.tours-link02 {
  margin-bottom: var(--dl-space-space-unit);
  text-decoration: none;
}
.tours-link03 {
  text-decoration: none;
}
.tours-container5 {
  display: flex;
  align-items: flex-start;
  margin-left: 100px;
  flex-direction: column;
}
.tours-link04 {
  margin-bottom: var(--dl-space-space-unit);
  text-decoration: none;
}
.tours-link05 {
  margin-bottom: var(--dl-space-space-unit);
  text-decoration: none;
}
.tours-link06 {
  margin-bottom: var(--dl-space-space-unit);
  text-decoration: none;
}
.tours-link07 {
  text-decoration: none;
}
.tours-follow-container {
  display: flex;
  align-items: center;
  margin-left: 50px;
  flex-direction: column;
  justify-content: space-between;
}
.tours-text4 {
  padding-bottom: var(--dl-space-space-halfunit);
}
.tours-icons-container {
  width: 100px;
  display: flex;
  align-self: flex-end;
  align-items: center;
  flex-direction: row;
  justify-content: center;
}
.tours-link08 {
  display: contents;
}
.tours-icon {
  fill: var(--dl-color-gray-white);
  width: 24px;
  height: 24px;
}
.tours-link09 {
  display: contents;
}
.tours-icon2 {
  fill: var(--dl-color-gray-white);
  width: 24px;
  height: 24px;
}
@media(max-width: 991px) {
  .tours-hero {
    padding-left: var(--dl-space-space-tripleunit);
    padding-right: var(--dl-space-space-tripleunit);
  }
}
@media(max-width: 767px) {
  .tours-hero {
    justify-content: center;
  }
  .tours-text {
    font-size: 2.5rem;
  }
  .tours-content-container {
    align-items: center;
  }
  .tours-main {
    padding-left: var(--dl-space-space-unit);
    padding-right: var(--dl-space-space-unit);
  }
  .tours-blog {
    padding-left: 32px;
    padding-right: 32px;
  }
  .tours-menu {
    flex-direction: column;
  }
  .tours-links-container {
    margin-top: var(--dl-space-space-tripleunit);
    margin-bottom: var(--dl-space-space-tripleunit);
    justify-content: space-between;
  }
  .tours-container4 {
    margin-left: 0px;
  }
}
@media(max-width: 479px) {
  .tours-text {
    font-size: 2rem;
    text-align: center;
  }
  .tours-subheading {
    font-size: 1.3rem;
    text-align: center;
  }
  .tours-blog {
    padding-top: 32px;
    padding-left: var(--dl-space-space-unit);
    padding-right: var(--dl-space-space-unit);
    padding-bottom: 32px;
  }
  .tours-container3 {
    position: relative;
    margin-bottom: 0px;
  }
  .tours-links-container {
    margin-top: var(--dl-space-space-doubleunit);
    align-items: flex-start;
    justify-content: flex-start;
  }
  .tours-link {
    margin-bottom: var(--dl-space-space-halfunit);
  }
  .tours-link01 {
    margin-bottom: var(--dl-space-space-halfunit);
  }
  .tours-link02 {
    margin-bottom: var(--dl-space-space-halfunit);
  }
  .tours-link03 {
    margin-bottom: var(--dl-space-space-halfunit);
  }
  .tours-container5 {
    height: 100%;
    align-items: flex-start;
    margin-left: 50px;
  }
  .tours-link04 {
    margin-bottom: var(--dl-space-space-halfunit);
  }
  .tours-link05 {
    margin-bottom: var(--dl-space-space-halfunit);
  }
  .tours-link06 {
    margin-bottom: var(--dl-space-space-halfunit);
  }
  .tours-link07 {
    margin-bottom: var(--dl-space-space-halfunit);
  }
  .tours-follow-container {
    margin-left: 0px;
  }
}
</style>
